import {
	Button,
	Checkbox,
	Col,
	Divider,
	Form,
	Input,
	InputNumber,
	Modal,
	Popconfirm,
	Row,
	Select,
	Space,
	Tabs,
	Typography,
	notification,
} from "antd";
import React, { useEffect, useState } from "react";
import Layout from "../layout/Layout";
import { api } from "../utils/Api";
import axios from "axios";
import { CustomSpinner, CustomTable } from "../utils/CustomComponents";
import {
	MinusCircleOutlined,
	PlusOutlined,
	RollbackOutlined,
} from "@ant-design/icons";
import PsiAggregateModal from "../aggregate/PsiAggregateModal";
import {
	formatTwoDecimals,
	getCogCost,
	getCogRowsTotal,
	getCogSubtotal,
} from "../utils/CogCost";

const { Title, Text } = Typography;

/**
 ** Options header (columns)
 */
const columns = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Previous Value",
		dataIndex: "previousValue",
		key: "previousValue",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Current Value",
		dataIndex: "currentValue",
		key: "currentValue",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Value",
		dataIndex: "value",
		key: "value",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

/**
 ** Options header (columns)
 */
const columnsAggregate = [
	{
		title: "Date",
		dataIndex: "date",
		key: "date",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Status",
		dataIndex: "status",
		key: "status",
		disabled: true,
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Previous Value",
		dataIndex: "previousValue",
		key: "previousValue",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Current Value",
		dataIndex: "currentValue",
		key: "currentValue",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "Value",
		dataIndex: "value",
		key: "value",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
	{
		title: "User",
		dataIndex: "user",
		key: "user",
		render: (value) => {
			return <Text>{value}</Text>;
		},
	},
];

const Product = (props) => {
	const [form] = Form.useForm();
	const [initialValues, setInitialValues] = useState({});
	const [loading, setLoading] = useState(true);
	const [loadingForm, setLoadingForm] = useState(true);
	const [historyData, setHistoryData] = useState([]);
	const [apiNotification, contextHolder] = notification.useNotification();
	const [plantOptions, setPlantOptions] = useState([]);
	const [plantOptionsCog, setPlantOptionsCog] = useState([]);
	const [activeAggKey, setActiveAggKey] = useState("0");
	// Base cog options per aggregate index (depends on the aggregate plant)
	const [optionsCogBaseMap, setOptionsCogBaseMap] = useState({});
	const [optionsCogMap, setOptionsCogMap] = useState({});
	const [modalNewOpen, setModalNewOpen] = useState(false);
	const [refresh, setRefresh] = useState(false);
	const [franchise, setFranchise] = useState("57Concrete");
	const [tabsVersion, setTabsVersion] = useState(0);

	const openNotification = (type, message, description) => {
		apiNotification[type]({
			message: message,
			description: description,
		});
	};

	useEffect(() => {
		getProduct();
	}, [refresh]);

	const getCogsByPlant = async (plantId, franchise) => {
		const url = api + `/cog/list/plant/${plantId}/${franchise}`;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			if (!data.success) {
				openNotification("error", "Error", "Error while trying to get cogs");
				return [];
			}
			let list = [];
			data.payload.map((item) => {
				list.push({
					value: `${item._id} ${item.unitOfConversion} ${item.unitPriceConversion}`,
					label: item.material,
				});
			});
			return list;
		} catch (err) {
			console.error(err.message);
			return [];
		}
	};

	const getPlants = async () => {
		const url = api + "/plant/list/57Concrete";
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			const { data } = await axios.get(url);
			let plantList = [];
			let plantList2 = [];
			data.payload.map((item) => {
				plantList.push({
					label: item.name,
					value: item._id,
				});
				plantList2.push({
					label: item.name,
					value: item._id,
				});
			});
			setPlantOptionsCog(plantList2);
			setPlantOptions(plantList);
			return plantList;
		} catch (err) {
			console.error(err.message);
			return [];
		}
	};

	// Build options with disabled flags based on selected cogs in ONE aggregate
	const buildOptionsForAggregate = (selectedValues = [], base = []) => {
		const set = new Set(selectedValues.filter(Boolean));
		return (base || []).map((opt) => ({
			...opt,
			disabled: set.has(opt.value),
		}));
	};

	// Get options for a specific aggregate index (fallback: compute from form)
	const getOptionsForAggregate = (aggIndex) => {
		if (optionsCogMap[aggIndex]) return optionsCogMap[aggIndex];
		const aggs = form.getFieldValue("aggregates") || [];
		const selected = (aggs[aggIndex]?.cogs || []).map((c) => c?.cog);
		return buildOptionsForAggregate(selected, optionsCogBaseMap[aggIndex]);
	};

	const getProduct = async () => {
		try {
			let url = api + `/psi/get/${props.match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			const { data } = await axios.get(url);

			const productFranchise = data.franchise || "57Concrete";
			setFranchise(productFranchise);

			// Load cogs once per plant used by the aggregates
			const plantIds = [
				...new Set(data.aggregates.map((a) => a.plant?._id).filter(Boolean)),
			];
			const cogsByPlant = {};
			await Promise.all(
				plantIds.map(async (plantId) => {
					cogsByPlant[plantId] = await getCogsByPlant(
						plantId,
						productFranchise,
					);
				}),
			);

			const aggregates = data.aggregates.map((aggregate) => {
				let currentCogs = [];
				let total = 0;
				aggregate.cogs.map((cog) => {
					currentCogs.push({
						cog: `${cog.cog._id} ${cog.cog.unitOfConversion} ${cog.cog.unitPriceConversion}`,
						unit: cog.cog.unitOfConversion,
						quantity: cog.quantity,
						name: cog.cog._id,
						price: sixPointDecimal(cog.cog.unitPriceConversion),
						subtotal: formatTwoDecimals(
							getCogCost(cog),
						),
					});
					total += getCogCost(cog);
				});

				let historyAggregate = [];
				aggregate.history.map((item, key) => {
					const result = item.value.split("-").join(" ");
					const value = result.charAt(0).toUpperCase() + result.slice(1);

					historyAggregate.push({
						key: key,
						date: Intl.DateTimeFormat("en-US").format(new Date(item.createdAt)),
						previousValue: item.previousValue,
						currentValue: item.currentValue,
						value: value,
						user: item.user.name,
						status: item.status || "-",
					});
				});
				if (aggregate.createdBy) {
					historyAggregate.push({
						key: historyAggregate.length,
						date: Intl.DateTimeFormat("en-US").format(
							new Date(aggregate.createdAt),
						),
						previousValue: "-",
						currentValue: "-",
						status: "-",
						value: "Created",
						user: aggregate.createdBy.name,
					});
				}

				return {
					_id: aggregate._id,
					plant: aggregate.plant._id,
					plantName: aggregate.plant.name,
					name: aggregate?.name ?? "",
					cogs: currentCogs,
					total: formatTwoDecimals(total),
					historyRows: historyAggregate,
				};
			});

			const plants = await getPlants();
			let optionsPlants = plants;
			let currentPlants = [];
			data.plants.map((plant) => {
				currentPlants.push({
					plant: plant.plant,
					commission: plant.commission,
				});
				let index = optionsPlants.findIndex((obj) => obj.value === plant.plant);
				optionsPlants[index].disabled = true;
			});

			form.resetFields();
			form.setFieldsValue({
				psi: data.psi,
				description: data.description,
				materialCost: data.materialCost,
				strength: data.strength,
				wcRatio: data.wcRatio,
				minPrice: data.minPrice || 0,
				price: data.price,
				active: data.active,
				isResidential: !!data.isResidential,
				isCommercial: !!data.isCommercial,
				aggregates,
				plants: currentPlants,
				commandProductId: data.commandProductId
			});

			setInitialValues({
				...initialValues,
				psi: data.psi,
				description: data.description,
				materialCost: data.materialCost,
				strength: data.strength,
				wcRatio: data.wcRatio,
				minPrice: data.minPrice || 0,
				price: data.price,
				active: data.active,
				isResidential: data.isResidential ? data.isResidential : false,
				isCommercial: data.isCommercial ? data.isCommercial : false,
				aggregates: aggregates,
				plants: currentPlants,
				commandProductId: data.commandProductId
			});

			const baseMap = {};
			const map = {};
			aggregates.forEach((agg, idx) => {
				const base = [...(cogsByPlant[agg.plant] || [])];
				// Keep already saved cogs selectable even if they are no longer
				// assigned to the plant, so the Select shows their name
				data.aggregates[idx].cogs.forEach((c) => {
					const value = `${c.cog._id} ${c.cog.unitOfConversion} ${c.cog.unitPriceConversion}`;
					if (!base.some((o) => o.value === value)) {
						base.push({ value, label: c.cog.material });
					}
				});
				baseMap[idx] = base;
				const selected = (agg.cogs || []).map((c) => c.cog);
				map[idx] = buildOptionsForAggregate(selected, base);
			});
			setOptionsCogBaseMap(baseMap);
			setOptionsCogMap(map);

			// move focus to the newest tab (last aggregate)
			if (aggregates.length > 0) {
				setActiveAggKey(String(aggregates.length - 1));
			}

			// force Tabs to rebuild its items after the new form values land
			setTabsVersion((v) => v + 1);

			let history = [];
			data.history.map((item, key) => {
				const currentValue =
					item.value.charAt(0).toUpperCase() + item.value.slice(1);
				const result = currentValue.match(/[A-Z][a-z]*/g).join(" ");

				history.push({
					key: key,
					date: Intl.DateTimeFormat("en-US").format(new Date(item.createdAt)),
					previousValue: item.previousValue,
					currentValue: item.currentValue,
					value: result,
					user: item.user.name,
				});
			});
			if (data.createdBy) {
				history.push({
					key: data.history.length,
					date: Intl.DateTimeFormat("en-US").format(new Date(data.createdAt)),
					previousValue: "-",
					currentValue: "-",
					value: "Created",
					user: data.createdBy.name,
				});
			}
			setHistoryData(history);

			setLoading(false);
			setLoadingForm(false);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to get product");
			console.error(err.message);
			return null;
		}
	};

	const updateProduct = async (data) => {
		setLoading(true);

		let currentAggregates = [];

		data.aggregates.map((aggregate) => {
			console.log(aggregate);
			let cCogs = [];
			aggregate.cogs.map((cog) => {
				let cogArray = cog.cog.split(" ");
				cCogs.push({
					cog: cogArray[0],
					quantity: cog.quantity,
				});
			});
			currentAggregates.push({
				_id: aggregate._id,
				plant: aggregate.plant,
				name: aggregate.name,
				cogs: cCogs,
			});
		});

		const dataForm = {
			...data,
			aggregates: currentAggregates,
			updatedBy: localStorage.getItem("userId"),
		};

		try {
			let url = api + `/psi/update/${props.match.params.id}`;
			const token = localStorage.getItem("token");
			axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

			await axios.patch(url, dataForm);
			openNotification("success", "Success", "Product updated");
			setTimeout(() => {
				setLoading(false);
				props.history.push("/psi/list");
			}, 1000);
		} catch (err) {
			setLoading(false);
			openNotification("error", "Error", "Error while trying to update user");
			console.error(err.message);
			return null;
		}
	};

	const deleteProduct = async () => {
		setLoading(true);

		const url = api + "/psi/update/" + props.match.params.id;
		const token = localStorage.getItem("token");
		axios.defaults.headers.common = { Authorization: `Bearer ${token}` };

		try {
			await axios.patch(url, { active: false });
			openNotification("info", "Info", "Product Deleted");
			setLoading(false);
			props.history.push("/psi/list");
		} catch (err) {
			setLoading(false);
			console.error(err.message);
			return null;
		}
	};

	const sixPointDecimal = (number) => Number(number).toFixed(6);

	const onChangePlant = () => {
		const plants = form.getFieldValue("plants") || [];

		const selectedPlants = plants.map((p) => p?.plant).filter(Boolean);

		const updatedOptions = plantOptions.map((option) => ({
			...option,
			disabled: selectedPlants.includes(option.value),
		}));

		setPlantOptions(updatedOptions);
	};

	const onRemovePlant = (removeFunction, name) => {
		removeFunction(name);
		const plants = form.getFieldValue("plants") || [];
		const selectedPlants = plants.map((p) => p?.plant).filter(Boolean);

		const updatedOptions = plantOptions.map((option) => ({
			...option,
			disabled: selectedPlants.includes(option.value),
		}));

		setPlantOptions(updatedOptions);
	};

	const onFinish = (values) => {
		updateProduct(values);
	};

	// When user selects a COG in a row
	const onChangeCog = (aggIndex, rowIndex, value) => {
		const aggregates = form.getFieldValue("aggregates");
		const cogs = aggregates?.[aggIndex]?.cogs ?? [];

		const updatedCogs = cogs.map((cog) => {
			if (cog !== undefined && cog.cog === value) {
				let cogArray = cog.cog.split(" ");
				return {
					...cog,
					unit: cogArray[1],
					price: sixPointDecimal(cogArray[2]),
					subtotal:
						cog.quantity !== undefined
							? formatTwoDecimals(getCogSubtotal(cogArray[2], cog.quantity))
							: 0,
				};
			}
			return cog;
		});

		form.setFields([
			{ name: ["aggregates", aggIndex, "cogs"], value: updatedCogs },
			{
				name: ["aggregates", aggIndex, "total"],
				value: formatTwoDecimals(getCogRowsTotal(updatedCogs)),
			},
		]);

		const selected = updatedCogs.map((r) => r?.cog).filter(Boolean);
		setOptionsCogMap((prev) => ({
			...prev,
			[aggIndex]: buildOptionsForAggregate(
				selected,
				optionsCogBaseMap[aggIndex],
			),
		}));
	};

	// When user changes the plant of an aggregate, reload its cogs
	const onChangePlantAgg = async (aggIndex, plantId) => {
		const base = await getCogsByPlant(plantId, franchise);
		const plantName = plantOptionsCog.find((p) => p.value === plantId)?.label;

		form.setFields([
			{ name: ["aggregates", aggIndex, "cogs"], value: [] },
			{ name: ["aggregates", aggIndex, "total"], value: formatTwoDecimals(0) },
			{ name: ["aggregates", aggIndex, "plantName"], value: plantName },
		]);

		setOptionsCogBaseMap((prev) => ({ ...prev, [aggIndex]: base }));
		setOptionsCogMap((prev) => ({
			...prev,
			[aggIndex]: buildOptionsForAggregate([], base),
		}));
	};

	// When user types a quantity in a row
	const onChangeQuantityAgg = (aggIndex, rowIndex, value) => {
		const aggregates = form.getFieldValue("aggregates");
		const cogs = aggregates?.[aggIndex]?.cogs ?? [];
		const updatedCogs = cogs.map((cog, index2) => {
			if (cog.cog !== undefined && rowIndex === index2) {
				let cogArray = cog.cog.split(" ");
				return {
					...cog,
					quantity: value,
					unit: cogArray[1],
					price: sixPointDecimal(cogArray[2]),
					subtotal: formatTwoDecimals(getCogSubtotal(cogArray[2], value)),
				};
			}

			return cog;
		});

		form.setFields([
			{ name: ["aggregates", aggIndex, "cogs"], value: updatedCogs },
			{
				name: ["aggregates", aggIndex, "total"],
				value: formatTwoDecimals(getCogRowsTotal(updatedCogs)),
			},
		]);
	};

	// Remove a COG row and recalc total
	const onRemoveCogRow = (aggIndex, remove, rowIndex) => {
		const aggregates = form.getFieldValue("aggregates");
		const cogs = aggregates?.[aggIndex]?.cogs ?? [];

		if (cogs[rowIndex] === undefined) {
			remove(rowIndex);
		} else if (!cogs[rowIndex].cog) {
			remove(rowIndex);
		} else {
			// Recalculate from the remaining rows: subtotals are truncated, so subtracting them would drift
			let newTotal = getCogRowsTotal(cogs.filter((_, i) => i !== rowIndex));

			form.setFields([
				{
					name: ["aggregates", aggIndex, "total"],
					value: formatTwoDecimals(newTotal),
				},
			]);
			const selected = cogs
				.filter((_, i) => i !== rowIndex)
				.map((r) => r?.cog)
				.filter(Boolean);
			setOptionsCogMap((prev) => ({
				...prev,
				[aggIndex]: buildOptionsForAggregate(
					selected,
					optionsCogBaseMap[aggIndex],
				),
			}));

			remove(rowIndex);
		}
	};

	const CustomForm = () => {
		return (
			<Form
				form={form}
				layout="vertical"
				initialValues={initialValues}
				onFinish={onFinish}
			>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Product"
							name="psi"
							rules={[
								{
									required: true,
									message: "Please fill psi",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Description"
							name="description"
							rules={[
								{
									required: true,
									message: "Please fill description",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Minimum Price"
							name="minPrice"
							rules={[
								{
									required: true,
									message: "Please fill minimum price",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Maximum Price"
							name="price"
							rules={[
								{
									required: true,
									message: "Please fill maximum price",
								},
								{
									validator: (_, value) => {
										if (value < form.getFieldValue("minPrice")) {
											return Promise.reject(
												new Error(
													`Maximum Price must be greater than ${form.getFieldValue(
														"minPrice",
													)}`,
												),
											);
										}
										return Promise.resolve();
									},
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label="Material Cost"
							name="materialCost"
							rules={[
								{
									required: true,
									message: "Please fill material cost",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item
							label="Strength"
							name="strength"
							rules={[
								{
									required: true,
									message: "Please fill strength",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
					<Col span={6}>
						<Form.Item
							label="W/C Ratio"
							name="wcRatio"
							rules={[
								{
									required: true,
									message: "Please fill ratio",
								},
							]}
						>
							<InputNumber
								size="large"
								style={{ width: "100%" }}
								formatter={(value) =>
									`${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
								}
								parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
							/>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={12}>
						<Form.Item
							label="Command Product ID"
							name="commandProductId"
							rules={[
								{
									required: true,
									message: "Please fill command product ID",
								},
							]}
						>
							<Input size="large" />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={8}>
						<Form.Item name="active" valuePropName="checked">
							<Checkbox>Is Active?</Checkbox>
						</Form.Item>
					</Col>
					<Col span={8}>
						<Form.Item name="isCommercial" valuePropName="checked">
							<Checkbox>Is Commercial?</Checkbox>
						</Form.Item>
					</Col>
					<Col span={8}>
						<Form.Item name="isResidential" valuePropName="checked">
							<Checkbox>Is Residential?</Checkbox>
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={16}>
					<Col span={24}>
						<Title level={3}>Plants Commission</Title>
					</Col>
					<Col span={24}>
						<Form.List name="plants">
							{(fields, { add, remove }) => (
								<>
									{fields.map(({ key, name, ...restField }) => (
										<Space
											key={key}
											style={{
												display: "flex",
												marginBottom: 8,
											}}
											align="baseline"
										>
											<Form.Item
												{...restField}
												name={[name, "plant"]}
												label="Plant"
												rules={[
													{
														required: true,
														message: "Plant is missing",
													},
												]}
											>
												<Select
													style={{
														width: "100%",
													}}
													size="large"
													placeholder="Please select plant"
													options={plantOptions}
													onChange={(e) => onChangePlant(e, name)}
												/>
											</Form.Item>
											<Form.Item
												{...restField}
												name={[name, "commission"]}
												label="Commission"
												rules={[
													{
														required: true,
														message: "Missing commission",
													},
												]}
											>
												<InputNumber
													size="large"
													style={{ width: "100%" }}
													formatter={(value) =>
														`$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
													}
													parser={(value) => value?.replace(/\$\s?|(,*)/g, "")}
												/>
											</Form.Item>

											<MinusCircleOutlined
												onClick={() => {
													onRemovePlant(remove, name);
												}}
											/>
										</Space>
									))}
									<Form.Item>
										<Button
											type="dashed"
											onClick={() => add()}
											block
											icon={<PlusOutlined />}
										>
											Add Plant
										</Button>
									</Form.Item>
								</>
							)}
						</Form.List>
					</Col>
				</Row>
				<Divider />
				<Title level={3}>History</Title>
				<CustomTable columns={columns} data={historyData} isScroll={false} />
				<Divider />
				<Row gutter={16}>
					<Col span={24}>
						<Title level={3}>Aggregate Details</Title>
					</Col>
					<Col span={24}>
						<Button
							type="primary"
							htmlType="button"
							size="large"
							onClick={() => setModalNewOpen(true)}
						>
							Add Aggregate
						</Button>
					</Col>
					<Col span={24}>
						<Form.List name="aggregates">
							{(aggFields) => {
								const items = aggFields.map((field, idx) => ({
									key: String(idx),
									label: (
										<span>
											{form.getFieldValue(["aggregates", idx, "plantName"]) ||
												`Aggregate ${idx + 1}`}
										</span>
									),
									children: (
										<>
											<Row gutter={16}>
												<Col span={12}>
													<Form.Item
														label="Name"
														name={[field.name, "name"]}
														rules={[
															{ required: true, message: "Please fill name" },
														]}
													>
														<Input size="large" />
													</Form.Item>
												</Col>
												<Col span={12}>
													<Form.Item
														label="Plant"
														name={[field.name, "plant"]}
														rules={[
															{
																required: true,
																message: "Plant is missing",
															},
														]}
													>
														<Select
															style={{
																width: "100%",
															}}
															size="large"
															placeholder="Please select plant"
															options={plantOptionsCog}
															onChange={(v) => onChangePlantAgg(idx, v)}
														/>
													</Form.Item>
												</Col>
											</Row>

											<Row gutter={16}>
												<Col span={24}>
													<Form.List name={[field.name, "cogs"]}>
														{(
															cogFields,
															{ add: addCog, remove: removeCog },
														) => (
															<>
																{cogFields.map((cField, rowIndex) => {
																	const {
																		key,
																		name: cogName,
																		...rest
																	} = cField;
																	return (
																		<Space
																			key={key}
																			style={{
																				display: "flex",
																				marginBottom: 8,
																			}}
																			align="baseline"
																		>
																			<Form.Item
																				{...rest}
																				name={[cogName, "quantity"]}
																				label="Quantity"
																				rules={[
																					{
																						required: true,
																						message: "Missing quantity",
																					},
																				]}
																			>
																				<InputNumber
																					size="large"
																					style={{ width: 140 }}
																					formatter={(v) =>
																						`${v}`.replace(
																							/\B(?=(\d{3})+(?!\d))/g,
																							",",
																						)
																					}
																					parser={(v) =>
																						v?.replace(/\$\s?|(,*)/g, "")
																					}
																					onChange={(v) =>
																						onChangeQuantityAgg(
																							idx,
																							rowIndex,
																							v,
																						)
																					}
																				/>
																			</Form.Item>

																			<Form.Item
																				{...rest}
																				name={[cogName, "cog"]}
																				label="Cog"
																				rules={[
																					{
																						required: true,
																						message: "Missing cog item",
																					},
																				]}
																			>
																				<Select
																					style={{ width: 320 }}
																					size="large"
																					placeholder="Please select cog"
																					options={getOptionsForAggregate(idx)}
																					onChange={(v) =>
																						onChangeCog(idx, rowIndex, v)
																					}
																				/>
																			</Form.Item>

																			<Form.Item
																				{...rest}
																				name={[cogName, "unit"]}
																				label="Unit"
																			>
																				<Input
																					disabled
																					size="large"
																					style={{ width: 110 }}
																				/>
																			</Form.Item>

																			<Form.Item
																				{...rest}
																				name={[cogName, "price"]}
																				label="Price"
																			>
																				<InputNumber
																					disabled
																					size="large"
																					style={{ width: 160 }}
																					formatter={(v) =>
																						`$ ${v}`.replace(
																							/\B(?=(\d{3})+(?!\d))/g,
																							"",
																						)
																					}
																					parser={(v) =>
																						v?.replace(/\$\s?|(,*)/g, "")
																					}
																				/>
																			</Form.Item>

																			<Form.Item
																				{...rest}
																				name={[cogName, "subtotal"]}
																				label="Subtotal"
																			>
																				<InputNumber
																					disabled
																					size="large"
																					style={{ width: 160 }}
																					formatter={(v) =>
																						`$ ${v}`.replace(
																							/\B(?=(\d{3})+(?!\d))/g,
																							"",
																						)
																					}
																					parser={(v) =>
																						v?.replace(/\$\s?|(,*)/g, "")
																					}
																				/>
																			</Form.Item>

																			<MinusCircleOutlined
																				onClick={() =>
																					onRemoveCogRow(
																						idx,
																						removeCog,
																						rowIndex,
																					)
																				}
																			/>
																		</Space>
																	);
																})}

																<Form.Item>
																	<Button
																		type="dashed"
																		onClick={() => addCog()}
																		block
																		icon={<PlusOutlined />}
																	>
																		Add Cog
																	</Button>
																</Form.Item>
															</>
														)}
													</Form.List>
												</Col>
											</Row>

											<Row gutter={16}>
												<Col span={4}>
													<Form.Item name={[field.name, "total"]} label="Total">
														<InputNumber
															size="large"
															style={{ width: "100%" }}
															disabled
															formatter={(v) =>
																`$ ${v}`.replace(/\B(?=(\d{3})+(?!\d))/g, "")
															}
															parser={(v) => v?.replace(/\$\s?|(,*)/g, "")}
														/>
													</Form.Item>
												</Col>
											</Row>

											<Divider />
											<Title level={3}>History Aggregate</Title>
											<CustomTable
												columns={columnsAggregate}
												data={
													form.getFieldValue([
														"aggregates",
														idx,
														"historyRows",
													]) || []
												}
												isScroll={false}
											/>
											<Divider />
										</>
									),
								}));

								return (
									<>
										<Tabs
											key={tabsVersion}
											items={items}
											activeKey={activeAggKey}
											onChange={setActiveAggKey}
										/>
									</>
								);
							}}
						</Form.List>
					</Col>
				</Row>

				<Row gutter={16}>
					<Col>
						<Button
							type="primary"
							htmlType="submit"
							loading={loading}
							size="large"
						>
							Save
						</Button>
					</Col>
					{localStorage.getItem("email") === "eliud@gmail.com" && (
						<Col>
							<Popconfirm
								title="Delete the product"
								description="Are you sure to delete this product?"
								okText="Yes"
								cancelText="No"
								onConfirm={deleteProduct}
							>
								<Button
									danger
									type="primary"
									htmlType="button"
									loading={loading}
									size="large"
								>
									Delete
								</Button>
							</Popconfirm>
						</Col>
					)}
				</Row>
			</Form>
		);
	};

	const onSuccessNew = () => {
		setModalNewOpen(false);
		setLoadingForm(true);
		setLoading(true);
		form.resetFields();
		setRefresh((prev) => !prev);
	};

	const ModalNewAggregate = () => {
		return (
			<Modal
				title="New Aggregate"
				open={modalNewOpen}
				onCancel={() => setModalNewOpen(false)}
				cancelButtonProps={{ style: { display: "none" } }}
				okButtonProps={{ style: { display: "none" } }}
				width={1000}
				centered
			>
				<PsiAggregateModal
					psiId={props.match.params.id}
					onSuccess={onSuccessNew}
					franchise={franchise}
				/>
			</Modal>
		);
	};

	const goBack = () => {
		props.history.goBack();
	};

	return (
		<Layout title="Product" description="Edit Product" type="medium">
			<Button
				type="primary"
				size="large"
				icon={<RollbackOutlined />}
				onClick={goBack}
			/>
			{loadingForm ? <CustomSpinner /> : <CustomForm />}
			<ModalNewAggregate />
			{contextHolder}
		</Layout>
	);
};

export default Product;
